import * as React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Fab from '@mui/material/Fab';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Avatar from '@mui/material/Avatar';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import MoreIcon from '@mui/icons-material/MoreVert';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { styled }, "@mui/material/AppBar": AppBar, "@mui/material/Box": Box, "@mui/material/CssBaseline": CssBaseline, "@mui/material/Toolbar": Toolbar, "@mui/material/Typography": Typography, "@mui/material/IconButton": IconButton, "@mui/material/Paper": Paper, "@mui/material/Fab": Fab, "@mui/material/List": List, "@mui/material/ListItemButton": ListItemButton, "@mui/material/ListItemAvatar": ListItemAvatar, "@mui/material/ListItemText": ListItemText, "@mui/material/ListSubheader": ListSubheader, "@mui/material/Avatar": Avatar, "@mui/icons-material/Menu": MenuIcon, "@mui/icons-material/Add": AddIcon, "@mui/icons-material/Search": SearchIcon, "@mui/icons-material/MoreVert": MoreIcon } } });
export default ClientProvider;
